module.exports = __webpack_public_path__ + "static/media/1012549.8f19ec4c.jpg";